module.exports = __webpack_public_path__ + "img/4.d65d0f9b.jpg";